<template>
  <div class="fp-item d-flex p-4" @click="$emit('view-product', product)">
    <img :src="image" />
    <div class="details d-flex flex-column pl-4">
      <div class="category-label" :style="`color: ${theme.featured_products_text_color}`">
        {{ product.category_name }}
      </div>
      <h5 class="product-label m-0" :style="`color: ${theme.featured_products_text_color}`">
        {{ product.product_name }}
      </h5>
      <div v-if="product.featured_callout" class="pill featured-pill d-flex align-items-center">
        <FeaturedIcon class="mr-1" style="width: 1rem; height: 1rem" />
        <div>{{ product.featured_callout }}</div>
      </div>
      <div v-if="!hidePrices" class="rounded p-1" :style="`color: ${theme.featured_products_badge_color};`">
        <span v-if="product.category_name == 'Pack To Order'"
          ><p style="font-weight: 600; font-size: 16px" class="mb-0">Variable</p>
          <p class="mb-0 small d-inline">/ Gram</p>
        </span>
        <div v-else :style="`color: ${theme.featured_products_badge_color};`">
          <div v-if="isDiscountedProduct(product)" class="d-inline pt-1">
            <p
              :style="`font-weight: 600; font-size: 16px; line-height: 16px; color: ${theme.featured_products_badge_color};`"
              class="p-0 m-0 d-inline"
            >
              {{ getProductTierMinMaxPrice(product) }}
            </p>
          </div>
          <div v-else>
            <p
              :style="`font-weight: 600; font-size: 16px; line-height: 16px; color: ${theme.featured_products_badge_color};`"
              class="p-0 m-0 d-inline"
            >
              {{ getProductMinMaxPrice(product) }}
            </p>
          </div>
          <p class="mb-0 small d-inline">
            /
            <span>{{ getUnit(product).name }}</span>
            <span v-if="product.packaged_unit_size" class="m-0"> - {{ product.packaged_unit_size }} </span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FeaturedIcon from "@/components/common/icons/FeaturedIcon.vue";
import { getUnit, getProductMinMaxPrice, isDiscountedProduct, getProductTierMinMaxPrice } from "@/services/storefront/storefront";

export default {
  components: {
    FeaturedIcon,
  },
  props: {
    theme: { type: Object, required: true },
    product: { type: Object, requried: true },
    hidePrices: { type: Boolean, default: false },
  },
  emits: ["view-product"],
  computed: {
    image() {
      const productImage = this.product.images[0];
      if (productImage) {
        return productImage.imageLink;
      }
      return "/img/misc/no-image-square.png";
    },
  },
  methods: {
    getUnit,
    getProductMinMaxPrice,
    isDiscountedProduct,
    getProductTierMinMaxPrice,
  },
};
</script>

<style lang="scss" scoped>
.fp-item {
  font-size: 0.75rem;
  user-select: none;
  cursor: pointer;

  img {
    height: 8em;
    border-radius: 1em;
  }

  .details {
    .category-label {
      font-size: 0.8em;
      font-weight: 400;
    }

    .pill {
      border: 1px solid var(--secondary);
      color: var(--secondary);
      border-radius: 1em;
      padding: 0 0.5em;
      margin-bottom: 0.25em;
      font-weight: 600;
      margin-left: -3px;

      &.featured-pill {
        border-width: 2px;
        border-color: #d4ac51;
        background: #edb926;
        color: white;
        width: max-content;
      }

      &.price-pill {
        width: min-content;
      }
    }
  }
}
</style>
